import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "header-wrapper" };
const _hoisted_3 = { class: "header-wrapper__header controls" };
const _hoisted_4 = { class: "left breadcrumbs-wrapper" };
const _hoisted_5 = { class: "breadcrumbs" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("a", { href: "/account-rewards" }, "Rewards")
], -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-angle-right",
        "aria-hidden": "true"
    })
], -1 /* HOISTED */);
const _hoisted_8 = ["href"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fas fa-angle-right",
        "aria-hidden": "true"
    })
], -1 /* HOISTED */);
const _hoisted_10 = {
    key: 0,
    class: "metadata"
};
const _hoisted_11 = { class: "right" };
const _hoisted_12 = { class: "header-wrapper__sub-header" };
const _hoisted_13 = { class: "panel-wrapper grid-view" };
const _hoisted_14 = { class: "row grid-view__primary-section" };
const _hoisted_15 = { class: "columns medium-7" };
const _hoisted_16 = { class: "panel-wrapper__content" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1 /* HOISTED */);
const _hoisted_18 = { class: "row grid-view__secondary-section" };
const _hoisted_19 = { class: "columns medium-4 panel-wrapper__content" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("small", null, "Reward Type", -1 /* HOISTED */);
const _hoisted_21 = { class: "columns medium-4 panel-wrapper__content" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("small", null, "Reward Value", -1 /* HOISTED */);
const _hoisted_23 = { class: "columns medium-4 panel-wrapper__content" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("small", null, "Last Fulfilled", -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1 /* HOISTED */);
const _hoisted_26 = { class: "row grid-view__secondary-section" };
const _hoisted_27 = { class: "columns medium-4 panel-wrapper__content" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("small", null, "Average Weekly Distribution", -1 /* HOISTED */);
const _hoisted_29 = { class: "columns medium-4 panel-wrapper__content" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("small", null, "Average Monthly Distribution", -1 /* HOISTED */);
const _hoisted_31 = { class: "columns medium-4 panel-wrapper__content" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("small", null, "Last Earned", -1 /* HOISTED */);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("div", { class: "panel-wrapper__header controls" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "left" }, [
        /*#__PURE__*/ _createElementVNode("h3", null, "Monthly Fulfilled Rewards"),
        /*#__PURE__*/ _createElementVNode("span", {
            class: "js-tooltip",
            "data-tooltip-id": "js-tooltip-monthly-custom-rewards-fulfilled"
        })
    ])
], -1 /* HOISTED */);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("div", { class: "panel-wrapper__header controls" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "left" }, [
        /*#__PURE__*/ _createElementVNode("h3", null, "Used In Campaigns")
    ])
], -1 /* HOISTED */);
import $ from "jquery";
import Strings from "src/shared/Strings";
import dateTimeService from "src/shared/date-time-service";
import { nextTick, onMounted, ref } from "vue";
import rewardStateSummaryService from "src/account-rewards/reward-state-summary-service";
import Button from "src/shared/v-components/ui/Button.vue";
import DateTime from "src/shared/DateTime";
import Numbers from "src/shared/Numbers";
import AllTimeStateSummaryBarChart from "src/account-rewards/AllTimeStateSummaryBarChart";
import { useRewardSupplier } from "src/shared/store/reward/supplier/composables";
import MonthlyRewardUsageChart from "src/account-rewards/MonthlyRewardUsageChart";
import RewardSupplierCampaignUsageView from "src/account-rewards/reward-supplier-campaign-usage/RewardSupplierCampaignUsageView";
import EditComponentDrawer from "src/shared/v-components/component/edit-component-drawer/EditComponentDrawer.vue";
import DrawerTrigger from "src/shared/v-components/ui/drawer/DrawerTrigger.vue";
const NO_VALUE = "--";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IntegrationRewardSupplierDetail',
    props: {
        rewardSupplierId: {}
    },
    setup(__props) {
        const props = __props;
        const { rewardSupplier } = useRewardSupplier(props.rewardSupplierId);
        const chartSummaryBar = ref();
        const lastFulfilled = ref(NO_VALUE);
        const averageMonthlyDistribution = ref(NO_VALUE);
        const lastEarned = ref(NO_VALUE);
        const averageWeeklyDistribution = ref(NO_VALUE);
        const monthlyFulfilled = ref();
        const usageInCampaigns = ref();
        const isEditDrawerOpened = ref(false);
        const createGraphView = (element) => {
            chartSummaryBar.value = element;
            if (chartSummaryBar.value) {
                nextTick(() => {
                    AllTimeStateSummaryBarChart.create($(chartSummaryBar.value), props.rewardSupplierId);
                });
            }
        };
        const createMonthlyFulfilled = (element) => {
            monthlyFulfilled.value = element;
            if (monthlyFulfilled.value) {
                nextTick(() => {
                    MonthlyRewardUsageChart.renderSupplierUsageInto(props.rewardSupplierId, $(monthlyFulfilled.value));
                });
            }
        };
        const createUsageInCampaigns = (element) => {
            usageInCampaigns.value = element;
            if (usageInCampaigns.value) {
                nextTick(() => {
                    RewardSupplierCampaignUsageView.showRewardSupplierUsage($(usageInCampaigns.value), props.rewardSupplierId);
                });
            }
        };
        const onSave = () => {
            isEditDrawerOpened.value = false;
        };
        const onDelete = () => {
            window.location.href = `${rewardSupplier.value.getTypeLink()}`;
        };
        onMounted(() => {
            nextTick(() => {
                rewardStateSummaryService
                    .getLastFulfilledDate(props.rewardSupplierId)
                    .done((value) => {
                    if (value) {
                        lastFulfilled.value = DateTime.formatDateTime(value);
                    }
                    else {
                        lastFulfilled.value = NO_VALUE;
                    }
                })
                    .fail(() => {
                    lastFulfilled.value = NO_VALUE;
                });
            });
            nextTick(() => {
                rewardStateSummaryService
                    .getLastEarnedDate(props.rewardSupplierId)
                    .done((value) => {
                    if (value) {
                        lastEarned.value = DateTime.formatDateTime(value);
                    }
                    else {
                        lastEarned.value = NO_VALUE;
                    }
                })
                    .fail(() => {
                    lastEarned.value = NO_VALUE;
                });
            });
            nextTick(() => {
                rewardStateSummaryService
                    .getAverageMonthlyDistribution(props.rewardSupplierId)
                    .done((value) => {
                    if (isNaN(value)) {
                        averageMonthlyDistribution.value = NO_VALUE;
                    }
                    else {
                        averageMonthlyDistribution.value = Numbers.humanize(value);
                    }
                })
                    .fail(() => {
                    averageMonthlyDistribution.value = NO_VALUE;
                });
            });
            nextTick(() => {
                rewardStateSummaryService
                    .getAverageWeeklyDistribution(props.rewardSupplierId)
                    .done((value) => {
                    if (isNaN(value)) {
                        averageWeeklyDistribution.value = NO_VALUE;
                    }
                    else {
                        averageWeeklyDistribution.value = Numbers.humanize(value);
                    }
                })
                    .fail(() => {
                    averageWeeklyDistribution.value = NO_VALUE;
                });
            });
        });
        return (_ctx, _cache) => {
            return (_unref(rewardSupplier))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("ul", _hoisted_5, [
                                    _hoisted_6,
                                    _hoisted_7,
                                    _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                            href: _unref(rewardSupplier).getTypeLink()
                                        }, _toDisplayString(_unref(rewardSupplier).getTypeDisplayName()), 9 /* TEXT, PROPS */, _hoisted_8)
                                    ]),
                                    _hoisted_9,
                                    _createElementVNode("li", null, [
                                        _createElementVNode("h1", null, _toDisplayString(_unref(Strings).capitalize(_unref(rewardSupplier).name)), 1 /* TEXT */)
                                    ]),
                                    (_unref(rewardSupplier).created_date)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_10, " Created: " + _toDisplayString(_unref(dateTimeService).formatToDateTime(_unref(rewardSupplier).created_date)), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(DrawerTrigger, null, {
                                    trigger: _withCtx(({ openDrawer }) => [
                                        _createVNode(Button, {
                                            level: "secondary",
                                            onClick: openDrawer
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(" Edit ")
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                    ]),
                                    drawer: _withCtx(({ drawerClosed }) => [
                                        (_unref(rewardSupplier).isIntegrationRewardSupplier())
                                            ? (_openBlock(), _createBlock(EditComponentDrawer, {
                                                key: 0,
                                                "component-id": _unref(rewardSupplier).getComponentId(),
                                                "should-publish": true,
                                                onSaved: _cache[0] || (_cache[0] = ($event) => (onSave())),
                                                onArchived: _cache[1] || (_cache[1] = ($event) => (onDelete())),
                                                onClosed: drawerClosed
                                            }, null, 8 /* PROPS */, ["component-id", "onClosed"]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("p", null, " Manage the distribution of " + _toDisplayString(_unref(rewardSupplier).display_type) + " including gifts, points and others. ", 1 /* TEXT */)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("h2", null, _toDisplayString(_unref(Strings).capitalize(_unref(rewardSupplier).name)), 1 /* TEXT */)
                                ])
                            ]),
                            _createElementVNode("div", { class: "columns medium-5" }, [
                                _createElementVNode("div", { class: "panel-wrapper__content" }, [
                                    _createElementVNode("div", { class: "chart chart--summary" }, [
                                        _createElementVNode("div", {
                                            ref: createGraphView,
                                            class: "chart-positioner"
                                        })
                                    ])
                                ])
                            ])
                        ]),
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("h3", null, _toDisplayString(_unref(Strings).capitalize(_unref(rewardSupplier).display_type)), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("h3", null, _toDisplayString(_unref(rewardSupplier).getFormattedValue()), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                _createElementVNode("h3", null, _toDisplayString(lastFulfilled.value), 1 /* TEXT */)
                            ])
                        ]),
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createElementVNode("h3", null, _toDisplayString(averageWeeklyDistribution.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("h3", null, _toDisplayString(averageMonthlyDistribution.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("h3", null, _toDisplayString(lastEarned.value), 1 /* TEXT */)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", {
                        id: "js-insights",
                        class: "row equal-height-panels equal-height-panels--small"
                    }, [
                        _createElementVNode("div", { class: "columns medium-6 panel-wrapper" }, [
                            _hoisted_33,
                            _createElementVNode("div", { class: "panel-wrapper__content chart" }, [
                                _createElementVNode("div", { ref: createMonthlyFulfilled })
                            ])
                        ]),
                        _createElementVNode("div", { class: "columns medium-6 panel-wrapper" }, [
                            _hoisted_34,
                            _createElementVNode("div", { ref: createUsageInCampaigns })
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
